import { render, staticRenderFns } from "./LetterboxContent.vue?vue&type=template&id=798347c0&scoped=true&"
import script from "./LetterboxContent.vue?vue&type=script&lang=ts&"
export * from "./LetterboxContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798347c0",
  null
  
)

export default component.exports